import { Link } from "react-router-dom";
import { MoveRight } from "lucide-react";
import { wardrobes } from "@/wardrobes";

export function WardrobesPage() {
  return (
    <div data-testid="wardrobes-page">
      <section className="page-hero">
        <div className="page-hero-copy">
          <span className="eyebrow">The wardrobe edit</span>
          <h1>Wardrobes that<br /><i>dress the room.</i></h1>
          <p>A wardrobe is the largest canvas in your bedroom. Ours are composed in solid wood, sprayed PU, seamless membrane and profile glass — four finishes, each engineered around the way you live and dress.</p>
          <Link to="/contact" className="button" data-testid="page-primary-cta">Start a conversation <MoveRight size={17} /></Link>
        </div>
        <img className="page-hero-portrait" src={wardrobes[3].image} alt={wardrobes[3].alt} />
      </section>
      <section className="content-section">
        <div>
          <span className="eyebrow">The collection</span>
          <h2>Ten designs.<br /><i>One obsession with detail.</i></h2>
          <div className="series-grid">
            {wardrobes.map((w) => (
              <Link to={`/wardrobes/${w.slug}`} className="series-card" key={w.slug} data-testid={`wardrobe-card-${w.index}`}>
                <img src={w.image} alt={w.alt} />
                <div>
                  <span>{w.index} / 10</span>
                  <h3>{w.name}</h3>
                  <p>{w.finish} · {w.layout}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
